import { Button, CardFooter, FormTitle, FormSubtitle } from "@impero-com/ui";

import FormCardContainer from "../components/formCardContainer";
import RightSideIcon from "../components/rightSideIcon";
import linkBrokenSvg from "../img/link-broken.svg";

import { getSharedErrorProps } from "./sharedError";

const AnonymousError = (props: AnonymousErrorProps) => {
    return (
        <FormCardContainer
            rightSide={
                <RightSideIcon
                    icon={props.icon ? props.icon : linkBrokenSvg}
                    customImages={false}
                />
            }
        >
            <FormTitle title={props.title} />
            <FormSubtitle subtitle={props.subtitle} />
            <CardFooter>
                <Button
                    id="anonymous-error-button"
                    variant="link"
                    onClick={props.action.handler}
                >
                    {props.action.label}
                </Button>
            </CardFooter>
        </FormCardContainer>
    );
};

interface AnonymousErrorProps {
    title: string;
    subtitle: string;
    icon?: any;
    action: {
        label: string;
        handler: () => void;
    };
}

interface AnonymousStatusErrorProps {
    code: number;
}
export function AnonymousStatusError({ code }: AnonymousStatusErrorProps) {
    const sharedProps = getSharedErrorProps(code);
    return <AnonymousError {...sharedProps} />;
}
